import toast from 'react-hot-toast';
import ReactHtmlParser from 'react-html-parser';
import { useMutation } from 'react-query';

import { trackNewUser } from '@tracking';
import {
  CreateUserForSubscribePageParams,
  createUserForSubscribePage,
} from '@utils/backend-api/users';

const useUserCreateForSubscribePage = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: CreateUserForSubscribePageParams) => createUserForSubscribePage(params),
    {
      onError: (error: { message: string; redirect_to?: string }) => {
        toast.error(ReactHtmlParser(error.message));
        if (error.redirect_to) {
          window.location.href = error.redirect_to;
        }
      },
      onSuccess: (response) => {
        if (response.isNewUser) {
          trackNewUser(response.email, response.leadType, {});
        }
        if (response.redirectTo) {
          window.location.href = response.redirectTo;
        }
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useUserCreateForSubscribePage;
